module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACNSURBVHgBfY8xDsIwDEXr9AKsuQVVlJ3eAEZuxm1YYYjiIzAlsNEDJKl/VVVR1dZLHP/3v2xqpIwxT3kuzXGxc65T6FJKt1LKZ4+EJkyPfjIw8z/n3G+ZMIMGBn+qRWvtWUSsd5phBHUCL0FtbQghfLXWPyK6TmlEd+/9q2ba9QoxRhbToJR6y5GPtT4CsDRIeMuP1hEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/Polygon 1.png
// module id = 487
// module chunks = 0